import { Grid, Paper, Typography } from '@material-ui/core';
import { CustomDivider } from '../atoms/Divider';

export const FormGeneric = ({ form, style = {}, center, onSubmit }) => {
    return (
        <form onSubmit={onSubmit}>
            <Grid
                container
                style={style}
                spacing={1}
                justifyContent={center ? 'center' : undefined}
                alignItems={center ? 'center' : undefined}
            >
                {form.map(({ Component, grid = {}, Card }, index) => (
                    <Grid key={index} item xs={12} {...grid}>
                        {Card ? (
                            <Grid
                                container
                                component={Paper}
                                spacing={1}
                                elevation={2}
                                style={{ padding: '1em' }}
                            >
                                {Card.title && (
                                    <>
                                        <Grid item xs={12} style={{ textAlign: 'center' }}>
                                            <Typography variant="h6" style={{ margin: '0.5em' }}>
                                                {Card.title.toUpperCase()}
                                            </Typography>
                                        </Grid>
                                        <CustomDivider />
                                    </>
                                )}
                                <Grid item xs={12} style={{ marginTop: '1em' }}>
                                    <Grid container spacing={1}>
                                        {Card.list.map(
                                            (
                                                { SubComponent, subGrid = {} },
                                                subIndex,
                                            ) => (
                                                <Grid key={subIndex} item xs={12} {...subGrid}>
                                                    {SubComponent}
                                                </Grid>
                                            ),
                                        )}
                                    </Grid>
                                </Grid>
                            </Grid>
                        ) : (
                            <> {Component} </>
                        )}
                    </Grid>
                ))}
            </Grid>
        </form>
    );
};
